import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'svg[repositoryOrigin]',
  standalone: true,
  template: ` <svg
    [ngClass]="styleClass"
    fill="#000000"
    xmlns="http://www.w3.org/2000/svg"
    width="800px"
    height="800px"
    viewBox="0 0 64 64"
  >
    <g>
      <path
        d="M60,0H4C1.789,0,0,1.789,0,4v56c0,2.211,1.789,4,4,4h56c2.211,0,4-1.789,4-4V4C64,1.789,62.211,0,60,0z
		 M56,32H44c-2.211,0-4,1.789-4,4v4H24v-4c0-2.211-1.789-4-4-4H8V8h48V32z"
      />
      <path d="M20,24h24c2.211,0,4-1.789,4-4s-1.789-4-4-4H20c-2.211,0-4,1.789-4,4S17.789,24,20,24z" />
    </g>
  </svg>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
})
export class RepositoryUiComponent {
  @Input() styleClass?: string;

  @HostBinding('attr.fill')
  public readonly fill = 'currentColor';

  @HostBinding('attr.viewBox')
  public readonly viewBox = '0 0 800 800';
}
